import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import Header from '@/components-latest/layout/Header'
import Tabs, { Tab } from '@/components-latest/shared/Tabs'
import HistoryOrders from '@/components-latest/ui/OrdersPage/HistoryOrders'
import InProgressOrders from '@/components-latest/ui/OrdersPage/InProgressOrders'
import NewOrders from '@/components-latest/ui/OrdersPage/NewOrders'
import ReadyOrders from '@/components-latest/ui/OrdersPage/ReadyOrders'
import {
  useFetchRejectionReasonsQuery,
  useGetOrdersCountByTypesQuery
} from '@/ducks/orders/services/orders.api'
import { selectStoreId } from '@/ducks/store/selectors/store.selectors'

import Styles from './OrdersPage.module.scss'

export const ORDERS_HEADER_ID = 'orders-header'

type RouteParams = {
  status?: 'new' | 'in-progress' | 'ready' | 'history'
}

const OrdersPage = () => {
  const { t } = useTranslation()

  const { status = 'new' } = useParams<RouteParams>()
  const storeId = useSelector(selectStoreId) || ''

  const { data: ordersCounts } = useGetOrdersCountByTypesQuery({
    store_id: storeId
  })

  useFetchRejectionReasonsQuery({ store_id: storeId })

  return (
    <div className={Styles.ordersPage}>
      <div id={ORDERS_HEADER_ID} className={Styles.extendedHeader}>
        <Header title="Orders" />
        <Tabs asNavigation>
          <Tab id="/orders/new" counter={ordersCounts?.new}>
            {t('orders.tabs.new')}
          </Tab>
          <Tab id="/orders/in-progress" counter={ordersCounts?.inProgress}>
            {t('orders.tabs.in-progress')}
          </Tab>
          <Tab id="/orders/ready">{t('orders.tabs.ready')}</Tab>
          <Tab id="/orders/history">{t('orders.tabs.history')}</Tab>
        </Tabs>
      </div>
      <div className={Styles.content}>
        {status === 'new' && <NewOrders />}
        {status === 'in-progress' && <InProgressOrders />}
        {status === 'ready' && <ReadyOrders />}
        {status === 'history' && <HistoryOrders />}
      </div>
    </div>
  )
}

export default OrdersPage
